import { render, staticRenderFns } from "./ExtendDownload.vue?vue&type=template&id=e5f6e708&scoped=true"
import script from "./ExtendDownload.vue?vue&type=script&lang=js"
export * from "./ExtendDownload.vue?vue&type=script&lang=js"
import style0 from "./ExtendDownload.vue?vue&type=style&index=0&id=e5f6e708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f6e708",
  null
  
)

export default component.exports